// NotificationModal.js
import React from 'react';
import Modal from 'olive-react-myoneui/lib/Modal';
import Button from 'olive-react-myoneui/lib/Button';

const ModalCommon = ({ show, onClose, title, children, footerButtons, className, backgroundColor, backdrop }) => {
  return (
    <Modal centered backdrop={backdrop} show={show} onHide={onClose} contentClassName={`p-4 ${className || ''}`}>
      <Modal.Header closeButton closeLabel="" style={{backgroundColor:backgroundColor}}>
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>
      <Modal.Body style={{backgroundColor:backgroundColor}}>{children}</Modal.Body>
        {footerButtons &&
        <Modal.Footer style={{backgroundColor:backgroundColor}}>
            {footerButtons.map((button, index) => (
                <Button
                key={index}
                variant={button.variant || "primary"}
                onClick={button.onClick || onClose}
                href={button.href}
                >
                {button.label}
            </Button>
            ))}
        </Modal.Footer>
        }
    </Modal>
  );
}

export default ModalCommon;
